export function formatBreakdownCopyLine(item, formatNumber, typeLabels) {
  const note = item.eligibilityNote ? `（${item.eligibilityNote}）` : "";
  return `${item.name}：${item.formula} = ${formatNumber(item.amount)} ${typeLabels[item.type]}${note}`;
}
